module.exports = __webpack_public_path__ + "static/media/step2img1.7517fec6.jpg";